import { Box, Chip } from "@mui/material";
import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TimerOffOutlinedIcon from "@mui/icons-material/TimerOffOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { Card, Divider, Typography } from "antd";
function AssessmentSection({ title, items }) {
  const statusConfig = {
    Submitted: {
      label: "تم التسليم",
      color: "success",
      icon: <CheckCircleOutlineIcon />,
    },

    Missed: {
      label: "لم يحضر",
      color: "error",
      icon: <CancelOutlinedIcon />,
    },

    InProgress: {
      label: "قيد الحل",
      color: "warning",
      icon: <AccessTimeIcon />,
    },

    Expired: {
      label: "انتهى الوقت",
      color: "default",
      icon: <TimerOffOutlinedIcon />,
    },

    NotStarted: {
      label: "لم يبدأ",
      color: "default",
      icon: <PlayCircleOutlineIcon />,
    },
  };
console.log(items)
  return (
    <Box className="assessment-section">
      <Typography className="section-title">{title}</Typography>

      <Card className="assessment-table-card">
        {items.length === 0 ? (
          <Box className="empty-section">
            <Typography>
              لا يوجد {title === "الاختبارات" ? "اختبارات" : "واجبات"} هذا الشهر
            </Typography>
          </Box>
        ) : (
          items.map((item, index) => {
            const status = statusConfig[item.status] || {
              label: "غير معروف",
              color: "default",
              icon: null,
            };

            return (
              <React.Fragment key={item.id}>
                {index > 0 && <Divider />}

                <Box className="assessment-row">
                  <Box className="assessment-info">
                    <Typography className="assessment-title">
                      {item.title}
                    </Typography>

                    <Typography className="assessment-date">
                      {item.date
                        ? new Date(item.date).toLocaleDateString("ar-EG")
                        : "-"}
                    </Typography>
                  </Box>

                  <Chip
                    icon={status.icon}
                    label={status.label}
                    color={status.color}
                    size="small"
                    sx={{
                      fontFamily: "Cairo, sans-serif",
                      fontWeight: 600,
                      minWidth: 110,
                      direction: "rtl",
                    }}
                  />

                  <Box className="assessment-score">
                    {item.score !== null && item.score !== undefined ? (
                      <>
                        <Typography className="score">
                          {item.score} / {item.totalPoints}
                        </Typography>

                        <Typography className="percentage">
                          {item.percentage}%
                        </Typography>
                      </>
                    ) : (
                      <Typography className="no-score">—</Typography>
                    )}
                  </Box>
                </Box>
              </React.Fragment>
            );
          })
        )}
      </Card>
    </Box>
  );
}

export default AssessmentSection;
